import { Color } from 'ng2-charts';
import * as moment from 'moment';

export const fontFamily = '"Muli", "Helvetica Neue", Helvetica, Arial, sans-serif';
export const fontStyle = 400;

const limeColor = {
  hex: '#cddc39',
  rgba: 'rgba(205, 220, 57, 0.22)'
};

const generateGradientFromRgba = (r, g, b) => {
  const canvasContext = document.createElement('canvas').getContext('2d');
  const gradient = canvasContext.createLinearGradient(0, 0, 0, 300);
  gradient.addColorStop(0, `rgba(${r}, ${g}, ${b}, 0.5)`);
  gradient.addColorStop(1, `rgba(${r}, ${g}, ${b}, 0.05)`);
  return gradient;
};

const greenColor = {
  hex: '#77ECC5',
  rgba: generateGradientFromRgba(119, 236, 197)
};

const nightGreenColor = {
  hex: '#21D196',
  rgba: generateGradientFromRgba(33, 209, 150)
};

const blueColor = {
  hex: '#56B0F2',
  rgba: generateGradientFromRgba(86, 176, 242)
};

const darkBlueColor = {
  hex: '#366BF3',
  rgba: generateGradientFromRgba(54, 107, 243)
};

export enum availableColors {
  lime = 'lime',
  green = 'green',
  nightGreen = 'nightGreen',
  blue = 'blue',
  darkBlue = 'darkBlue'
}

export const chartLineColor = {
  [availableColors.lime]: generateLineChartColor(limeColor.hex, limeColor.rgba),
  [availableColors.green]: generateLineChartColor(greenColor.hex, greenColor.rgba),
  [availableColors.nightGreen]: generateLineChartColor(nightGreenColor.hex, nightGreenColor.rgba),
  [availableColors.blue]: generateLineChartColor(blueColor.hex, blueColor.rgba),
  [availableColors.darkBlue]: generateLineChartColor(darkBlueColor.hex, darkBlueColor.rgba)
};

export const chartDoughnutColor = generateDoughnutChartColor([greenColor, limeColor, nightGreenColor]);

function generateLineChartColor(hex: string, rgba: string | CanvasGradient): any {
  return {
    backgroundColor: rgba,
    borderColor: hex,
    pointBackgroundColor: hex,
    pointBorderColor: hex,

    pointHoverBackgroundColor: '#fff',
    pointHoverBorderColor: hex
  };
}

function generateDoughnutChartColor(colors): Color {
  const hexs = colors.map(el => el.hex);
  const whites = colors.map(el => '#fff');
  return {
    backgroundColor: hexs,
    hoverBackgroundColor: hexs,
    borderColor: whites
  };
}

export const tooltips = {
  tooltips: {
    backgroundColor: '#fff',
    titleFontColor: '#c6c6c6',

    bodyFontColor: '',
    borderWidth: 0.5,
    borderColor: '#c6c6c6',
    displayColors: false,
    titleFontFamily: fontFamily,
    titleFontStyle: fontStyle,
    bodyFontFamily: fontFamily,
    bodyFontStyle: fontStyle,
    yPadding: 10,
    cornerRadius: 2,
    callbacks: {
      title(tooltipItem, data) {
        if (data.datasets[0].date) {
          return moment(data.datasets[0].date[tooltipItem[0].index]).format('dddd, MMM DD, HH:mm');
        }
      }
    }
  }
};

export const defaultChartConfig = {
  ...tooltips,
  plugins: {
    datalabels: {
      // hide datalabels for all datasets
      display: false
    }
  },
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    onClick: function(e) {
      e.stopPropagation();
    }
  },
  layout: {
    padding: {
      top: 16,
      right: 0,
      left: 0,
      bottom: 0
    }
  }
};
